var React = require('react');

function Starempty (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#E6EBEF","points":"8.223,0 10.764,5.149 16.446,5.974 12.334,9.982 13.305,15.641 8.223,12.969 3.141,15.641 \r\n\t4.111,9.982 0,5.974 5.682,5.149 "}));
}

Starempty.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"16.446px","height":"15.641px","viewBox":"0 0 16.446 15.641","enableBackground":"new 0 0 16.446 15.641","xmlSpace":"preserve"};

module.exports = Starempty;

Starempty.default = Starempty;
